import clsx from "clsx";

import { type CellContext } from "@tanstack/react-table";

interface TableCellProps<TData> {
  cell: CellContext<TData, unknown>;
  formattedValue?: string | number;
}

export const CellNumberFormatter = <TData,>(props: TableCellProps<TData>) => {
  return (
    <div
      className={clsx(
        "text-v2-primary h-full px-4 py-2.5 bg-inherit font-mono text-xs",
        "flex items-center justify-end break-all",
      )}
      title={String(props.formattedValue) ?? String(props.cell.getValue())}
    >
      {props.formattedValue ?? String(props.cell.getValue())}
    </div>
  );
};
